import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';

export const RESET_BUY_PACKAGE = 'BUY_PACKAGE :: RESET';

export type TResetBuyPackageAction = IReduxAction<typeof RESET_BUY_PACKAGE>;

export const resetBuyPackage = actionGenerator<typeof RESET_BUY_PACKAGE>(RESET_BUY_PACKAGE);
